import { RfidBadgeOrderStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/user-service-lib/src/wrapper/enums/rfid-badge-order-status.enum';

interface EmspBoRfidBadgeOrderStatusStyle {
  color: string;
}

const EMSP_BO_RFID_BADGE_ORDER_STATUS_STYLE_MAP: Record<
  RfidBadgeOrderStatus,
  EmspBoRfidBadgeOrderStatusStyle
> = {
  [RfidBadgeOrderStatus.PENDING]: { color: 'bg-surface-warning' },
  [RfidBadgeOrderStatus.CONFIRMED]: { color: 'bg-surface-informations' },
  [RfidBadgeOrderStatus.PAID]: { color: 'bg-surface-informations' },
  [RfidBadgeOrderStatus.SHIPPED]: { color: 'bg-surface-charging' },
  [RfidBadgeOrderStatus.COMPLETED]: { color: 'bg-surface-success' },
  [RfidBadgeOrderStatus.CANCELLED]: { color: 'bg-surface-error' },
};

export const mapEmspBoRfidBadgeOrderStatusToStyle = (
  status: RfidBadgeOrderStatus,
): EmspBoRfidBadgeOrderStatusStyle => {
  return (
    EMSP_BO_RFID_BADGE_ORDER_STATUS_STYLE_MAP[status] ?? {
      color: 'bg-surface-brand-secondary',
    }
  );
};
